import styled from 'styled-components';

const CardReviewHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 0 0 16px 0;
`;

export default CardReviewHeader;